import React from 'react'
import { Routes, Route } from 'react-router-dom'
import DocumentEditor from './components/DocumentEditor'
import WelcomePage from './components/WelcomePage'

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        <Route path="/" element={<WelcomePage />} />
        <Route path="/editor" element={<DocumentEditor />} />
      </Routes>
    </div>
  )
}

export default App 